const STEPS = [
  {
    n: "01",
    name: "Discovery Call",
    desc:
      "We learn your property, fleet size, and schedule requirements. No obligations — just a focused conversation about what your exterior actually needs.",
  },
  {
    n: "02",
    name: "Site Assessment",
    desc:
      "We walk your property, run an ATP baseline test, document your fleet, and build a custom service program tailored to your operation.",
  },
  {
    n: "03",
    name: "First Service",
    desc:
      "We execute your first full service visit and deliver your initial Cart Condition Report — with before-and-after bacteria scores and a full asset log.",
  },
  {
    n: "04",
    name: "Ongoing Operations",
    desc:
      "We run on schedule, every visit fully documented. You receive reports, we manage the exterior. You focus on what's inside your walls.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-16 md:py-32 bg-[var(--xw-bg)] border-b border-[var(--xw-line)]"
    >
      <div className="xw-container">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono-xw text-[11px] tracking-[0.22em] uppercase text-[var(--xw-orange)]">
                § 04 — Our Process
              </span>
              <span className="h-px w-16 bg-[var(--xw-line)]" />
            </div>
            <h2
              data-testid="process-headline"
              className="font-display font-black uppercase tracking-[-0.03em] leading-[0.9]"
              style={{ fontSize: "clamp(2rem, 7vw, 5rem)" }}
            >
              Simple To Start. <br />
              <span className="italic font-medium" style={{ color: "var(--xw-orange)" }}>
                Built To Last.
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <p className="text-[16px] md:text-[17px] leading-relaxed text-[var(--xw-ink-soft)]">
              From first contact to first service, most clients are fully
              onboarded within one week.
            </p>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-[var(--xw-line)]">
          {STEPS.map((s, i) => {
            const noLeftSm = i % 2 === 0 ? "sm:border-l-0" : "sm:border-l";
            const noLeftLg = i % 4 === 0 ? "lg:border-l-0" : "lg:border-l";
            const topBorder = i >= 2 ? "border-t sm:border-t-0" : "";
            return (
              <div
                key={s.n}
                data-testid={`process-step-${i}`}
                className={`py-8 md:py-10 pr-6 sm:pl-6 md:pl-8 border-[var(--xw-line)] ${noLeftSm} ${noLeftLg} ${topBorder} xw-reveal`}
              >
                <div className="flex items-baseline gap-3">
                  <span
                    className="xw-num text-[64px] sm:text-[80px] md:text-[104px]"
                    style={{ color: "var(--xw-orange)" }}
                  >
                    {s.n}
                  </span>
                </div>
                <h3 className="mt-2 font-display font-bold text-xl sm:text-2xl tracking-tight uppercase">
                  {s.name}
                </h3>
                <p className="mt-3 text-[14px] sm:text-[14.5px] text-[var(--xw-ink-soft)] leading-relaxed max-w-[32ch]">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
